<template>
  <v-card v-if="maxPlan" class="rounded-card pa-2 d-flex align-center justify-space-between" flat>
    <p class="mb-0 font--m-5 color--gray-80">
      지금 <strong>{{ (maxPlan.limit - currentPlan.limit) | commaFormat }}원</strong>을 추가 할 수
      있어요.
    </p>
    <v-btn
      id="btn__5FhzEqnEek2AeCJuAWAjcw=="
      width="65px"
      height="35px"
      color="white"
      class="font--m-8 color--gray-100"
      depressed
      :to="{ name: 'my/plans' }"
    >
      <strong>추가하기</strong>
    </v-btn>
  </v-card>
</template>
<script>
import { simpleClone } from '@/util'
export default {
  props: {
    plan: {
      type: Object,
      required: true,
    },
    plans: {
      type: Array,
      required: true,
    },
  },
  created() {},
  computed: {
    maxPlan() {
      return this.sortPlans.find((v) => this.currentPlan.limit < v.limit)
    },
    sortPlans() {
      const plans = simpleClone(this.plans)
      return plans.sort((a, b) => {
        if (a.limit < b.limit) {
          return 1
        } else if (a.limit > b.limit) {
          return -1
        }
        return 0
      })
    },
    currentPlan() {
      if (!this.plan) {
        return {}
      }
      // 내 choice를 찾아서 객체를 찾아냄
      return this.plans.find((v) => v.uuid === this.plan.uuid)
    },
  },
  methods: {},
}
</script>
